import { render } from "./radiusPolarChart9Sides.vue?vue&type=template&id=1f433b6c&scoped=true"
import script from "./radiusPolarChart9Sides.vue?vue&type=script&lang=js"
export * from "./radiusPolarChart9Sides.vue?vue&type=script&lang=js"

import "./radiusPolarChart9Sides.vue?vue&type=style&index=0&id=1f433b6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f433b6c"]])

export default __exports__